import { render, staticRenderFns } from "./MeasurementsDictionary.vue?vue&type=template&id=03bf3300&lang=pug&"
import script from "./MeasurementsDictionary.vue?vue&type=script&lang=js&"
export * from "./MeasurementsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports